
import React from 'react';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from '@/components/ui/input';
import { UseFormReturn } from 'react-hook-form';
import { z } from 'zod';

// The schema is defined in the parent form
interface EmailFieldProps {
  form: UseFormReturn<any>;
}

const EmailField: React.FC<EmailFieldProps> = ({ form }) => {
  return (
    <FormField
      control={form.control}
      name="email"
      render={({ field }) => (
        <FormItem>
          <FormLabel className="text-hormony-charcoal">
            Email Address
          </FormLabel>
          <FormControl>
            <Input
              {...field}
              type="email"
              placeholder="Enter your email"
              autoComplete="email"
              className="appearance-none rounded-lg relative block w-full"
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default EmailField;
